module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/030-north-korea-5ae20769c6d809e5fa6538a909544cd4.svg";